import { useTranslation } from 'react-i18next'

import { EmailInput, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { inputMaxLengths } from '@/constants'

import * as Styles from './styles'

const GiftRecipientFields = ({ giftRecipient, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMRegular">{t('Introduce tus datos de contacto')}</Text>
      <div>
        <InputWithLabel
          label={t('Nombre')}
          fullWidth
          onChange={e => onChange('first_name', e.target.value)}
          value={giftRecipient?.first_name || ''}
          name="firstName"
          maxLength={inputMaxLengths.first_name}
        />
        <InputWithLabel
          label={t('Apellidos')}
          fullWidth
          onChange={e => onChange('last_name', e.target.value)}
          value={giftRecipient?.last_name || ''}
          name="lastName"
          maxLength={inputMaxLengths.last_name}
        />
        <EmailInput
          iconUrl="/icons/email.svg"
          onChange={e => onChange('email', e.target.value)}
          textPadding="2.2rem"
          value={giftRecipient?.email || ''}
          name="giftRecipientEmail"
          label={t('Email')}
          maxLength={inputMaxLengths.orderEmail}
        >
          {giftRecipient?.email}
        </EmailInput>
      </div>
    </Styles.Container>
  )
}

export default GiftRecipientFields
